const baseTimestamp = { seconds: "0", nanos: 0 };
const Timestamp = {
  fromJSON(object) {
    const message = { ...baseTimestamp };
    message.seconds = object.seconds !== void 0 && object.seconds !== null ? String(object.seconds) : "0";
    message.nanos = object.nanos !== void 0 && object.nanos !== null ? Number(object.nanos) : 0;
    return message;
  },
  toJSON(message) {
    const obj = {};
    message.seconds !== void 0 && (obj.seconds = message.seconds);
    message.nanos !== void 0 && (obj.nanos = Math.round(message.nanos));
    return obj;
  }
};
export {
  Timestamp
};
//# sourceMappingURL=timestamp.js.map
